import isBrowser from './isBrowser';
import createElement from './dom/createElement';
var MEASURE_STYLE = {
    position: 'absolute',
    top: '-9999px',
    width: '50px',
    height: '50px',
    overflow: 'scroll',
};
function getScrollbarWidth() {
    if (!isBrowser) {
        return 0;
    }
    var scrollDiv = createElement('div');
    Object.assign(scrollDiv.style, MEASURE_STYLE);
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}
export var SCROLLBAR_WIDTH = getScrollbarWidth();
